import { MARKET_EXECUTIVE_COMMISSION_COMPANY_FAILED, MARKET_EXECUTIVE_COMMISSION_COMPANY_REQUEST, MARKET_EXECUTIVE_COMMISSION_COMPANY_SUCCESS } from "app/utils/constants/MarketExecutiveCompany"

const INTI_VALUES_COMPANY = {
    loading: false,
    marketExecutiveCommissionCompanyList: [],
    totalPage:0,
    error: false,
    errorMessage: null
}

export const marketExcutiveCommissionCompanyReducer = (state = INTI_VALUES_COMPANY, action) => {
    switch (action.type) {
        case MARKET_EXECUTIVE_COMMISSION_COMPANY_REQUEST:
            return { ...state, loading: true }
        case MARKET_EXECUTIVE_COMMISSION_COMPANY_SUCCESS:
            return {
                ...state,
                marketExecutiveCommissionCompanyList: action.payload.marketExecutiveCommissionCompanyList,
                totalPage:action.payload.totalPage,
                loading: false
            }
        case MARKET_EXECUTIVE_COMMISSION_COMPANY_FAILED:
            return {
                ...state,
                error: true,
                message: action.payload
            }
        default:
            return state;
    }
}